import { render, staticRenderFns } from "./MailQue.vue?vue&type=template&id=493b29c3&scoped=true"
import script from "./MailQue.vue?vue&type=script&lang=js"
export * from "./MailQue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493b29c3",
  null
  
)

export default component.exports